import { Radio } from 'antd'
import React from 'react'

interface RolesAuthorizationProps {
  placeholder: string
  icon?: React.ReactNode
  iconPositionStart?: boolean
}

export const RolesAuthorization = ({ placeholder, icon, iconPositionStart = true }: RolesAuthorizationProps) => {
  return (
    <Radio.Group className="d-flex flex-nowrap me-2">
      <div className="d-flex gap-2 justify-content-start align-items-center px-3 py-2 fs-6 rounded rounded-end-0 border border-1 border-end-0 border-secondary">
        {iconPositionStart ? icon : null}
        {placeholder}
      </div>

      <div className="px-3 py-2 fs-6 d-flex align-items-center rounded rounded-start-0 border border-1 border-secondary">
        {!iconPositionStart && icon} 3/3
      </div>
    </Radio.Group>
  )
}
